module.exports = __webpack_public_path__ + "static/media/mbl-feedback-empty.39242827.svg";